module.exports = __webpack_public_path__ + "img/网页 (1).3703a77a.svg";